import { create } from 'zustand';
import type {
  BenefitDesignInputs,
  BenefitPaymentType,
  CombinedFilterType,
  InflationType,
} from '@/features/shop-insurance';

interface BenefitDesignInputsState {
  inputs: BenefitDesignInputs;
  actions: {
    setMonthlyBenefit: (value: number | null) => void;
    setBenefitDuration: (value: CombinedFilterType | null) => void;
    setInflationProtection: (value: number | null) => void;
    setInflationProtectionRange: (value: CombinedFilterType | null) => void;
    setInflationTypes: (value: InflationType[] | null) => void;
    setBenefitPaymentType: (value: BenefitPaymentType | null) => void;
    reset: () => void;
  };
}

const DEFAULT_INPUTS: BenefitDesignInputs = {
  monthlyBenefit: null,
  benefitDuration: null,
  inflationProtection: null,
  inflationProtectionRange: null,
  inflationTypes: null,
  benefitPaymentType: null,
};

export const useBenefitDesignInputsStore = create<BenefitDesignInputsState>(set => ({
  inputs: { ...DEFAULT_INPUTS },
  actions: {
    setMonthlyBenefit: value =>
      set(state => ({ inputs: { ...state.inputs, monthlyBenefit: value } })),
    setBenefitDuration: value =>
      set(state => ({ inputs: { ...state.inputs, benefitDuration: value } })),
    setInflationProtection: value =>
      set(state => ({ inputs: { ...state.inputs, inflationProtection: value } })),
    setInflationProtectionRange: value =>
      set(state => ({ inputs: { ...state.inputs, inflationProtectionRange: value } })),
    setInflationTypes: value =>
      set(state => ({ inputs: { ...state.inputs, inflationTypes: value } })),
    setBenefitPaymentType: value =>
      set(state => ({ inputs: { ...state.inputs, benefitPaymentType: value } })),
    reset: () => set({ inputs: { ...DEFAULT_INPUTS } }),
  },
}));

export const useBenefitDesignInputs = () =>
  useBenefitDesignInputsStore(state => state.inputs);

export const useBenefitDesignInputsActions = () =>
  useBenefitDesignInputsStore(state => state.actions);
